// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import CcmsAuthPage from './CcmsAuthPage';
import CcmsDataDisplayPage from './CcmsDataDisplayPage';
import CcmsFileManagementPage from './CcmsFileManagementPage';
import CcmsRealtimePage from './CcmsRealtimePage';
import CcmsSharedPage from './CcmsSharedPage';
import CcmsPresencePage from './CcmsPresencePage';
import CcmsAccessControlPage from './CcmsAccessControlPage';

export default function CcmsRoutes() {
  return (
    <Routes>
      <Route path="auth" element={<CcmsAuthPage />} />
      <Route path="data-display" element={<CcmsDataDisplayPage />} />
      <Route path="file-management" element={<CcmsFileManagementPage />} />
      <Route path="realtime" element={<CcmsRealtimePage />} />
      <Route path="shared" element={<CcmsSharedPage />} />
      <Route path="presence" element={<CcmsPresencePage />} />
      <Route path="access-control" element={<CcmsAccessControlPage />} />
    </Routes>
  );
}
